import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonBase, Grid, styled, Typography, alpha, Box } from '@mui/material';


import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';


interface IIconCardProps {
    uri: string;
    title: string;
    icon: IconDefinition;
}

const StyledButton = styled(ButtonBase)(({theme}) => ({
    cursor: 'pointer',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    background: theme.palette.background.paper,
    backgroundImage: theme.palette.mode === 'dark' ? 
        `linear-gradient(${alpha(theme.palette.common.white, 0.05)}, ${alpha(theme.palette.common.white, 0.05)})` :
        undefined,

    boxShadow: theme.shadows[1],
    borderRadius: theme.shape.borderRadius,

    '&:hover': {
        background: theme.palette.mode === 'dark' ? alpha(theme.palette.secondary.dark, 0.25) : alpha(theme.palette.secondary.main, 0.15)
    }
}))

const StyledTitle = styled(Typography)(({theme}) => ({
    padding: theme.spacing(3)
}))

const IconWrapper = styled(Box)(({theme}) => ({
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
    width: '100%',
    padding: theme.spacing(3),
    background: theme.palette.mode === 'dark' ?  theme.palette.primary.dark : theme.palette.primary.main,
    color: theme.palette.common.white,
    flex: '1 1 auto'
}));

const IconCard: FunctionComponent<IIconCardProps> = ({
    icon,
    uri,
    title
}) => {
    return (
        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
            <StyledButton
                //@ts-ignore-next-line
                component={Link}
                to={uri}
                color="inherit"
            >
                <IconWrapper>
                    <FontAwesomeIcon icon={icon} size="6x" fixedWidth />
                </IconWrapper>
                <StyledTitle
                    variant="h4"
                >
                    {title}
                </StyledTitle>
            </StyledButton>
        </Grid>
    )
};

export default IconCard;